<template>
  <div>
    <div class="meeting-room" v-if="meeting_arr">会议室</div>
    <div>
        <div v-for="(item,index) in meeting_arr" :key="item.id" class="meeting-item-container mb-3">
            <div class="meeting-title mb-2">
                {{item.title}}
            </div>
            <div class="meeting-info">
                <div class="meeting-banner">
                    <img v-lazy="ImgPreUrl+item.pic[0]" height="14px" class="meeting-img gallery-img" @click="$emit('meetingDetails',item)" @mouseenter="isZoomed = index" @mouseleave="isZoomed = -1" :style="{ transform: isZoomed==index ? 'scale(1.1)' : 'scale(1)' }"></img>
                    <div class="meeting-pic-num">
                        <i class="iconfont icon-tupian"></i>
                        <span>{{ item.pic.length }}</span>
                    </div>
                </div>
                <div class="meeting-price">
                    <div class="meeting-price-left">
                        <div class="meeting-price-layout">详<br/>情</div>
                        <div>
                            <i class="iconfont icon-mianjizhanbi"></i>
                            <p>面积</p>
                            <div>{{ item.area }}m²</div>
                        </div>
                        <div>
                            <i class="iconfont icon-cenggao "></i>
                            <p>层高</p>
                            <div>{{ item.high }}m</div>
                        </div>
                        <div>
                            <i class="iconfont icon-lizhu"></i>
                            <p :class="{'text-red':item.pillar==0}">{{ item.pillar | formatVar('MeetingPillar')||'/'}}</p>
                            <!-- <div>柱子</div> -->
                        </div>
                        <div>
                            <i class="iconfont icon-chuanghu"></i>
                            <p :class="{'text-red':item.window==0}">{{ item.window | formatVar('windowStyle')||'/'}}</p>
                            <!-- <div>窗户</div> -->
                        </div>
                    </div>
                    <div class="meeting-price-left">
                        <div class="meeting-price-layout">布<br/>局</div>   
                        <div v-for="(item,index) in layout(item.layout_arr)" :key="index">
                            <img v-lazy="'/images/bj/icon_'+item.type+'.png'" height="14px" class="meeting-price-img"/>
                            <p>{{item.name }}</p>
                            <div :class="{'text-red':item.num==''}">{{ item.num||'/' }}<span v-if="item.num">人</span></div>
                        </div>
                    </div>  
                    <div class="meeting-price-bottom" @click="$emit('meetingDetails',item)">会议详情</div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {
    meeting_arr: {},
  },
  data() {
    return {
        isZoomed:-1,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    layout(e){
        let layoutarr=[
            { type: 1, name: '剧院式',num:'',status:true},
            { type: 2, name: '课桌式',num:'',status:true},
            { type: 3, name: '岛屿式',num:'',status:true},
        ];
        if(Array.isArray(e)){
            this.$verify.matchAndAssign(e,layoutarr,'type',['num'])
        }
        return layoutarr
    }
  }
};
</script>

<style lang="scss" scoped>
.meeting-room{
    width: 100%;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin: 10px 0;
}
.meeting-item-container{
    background-color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 1%;
}
.meeting-title{
    font-size: 18px;
    font-weight: bold;
}
.meeting-info{
    display: flex;
    justify-content: space-between;
}
.meeting-banner{
    position: relative;
    height: 120px;
    overflow: hidden;
}
.meeting-img{
    width: 206px;
    height: 120px;
    border-radius: 4px;
}
.meeting-pic-num{
    position: absolute;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .6);
    color: #fff;
    width: 34px;
    padding: 3px 0;
    border-radius: 4px 0 0 0;
    text-align: center;
    font-size: 12px;
    i{
    margin-right: 4px;
    font-size: 12px;
    }

}
.meeting-price{
    width: 80%;
}
.meeting-price-left{
    float: left;
    background-color: #f5f7fa;
    display: flex;
    margin-right: 20px;
    border-radius: 6px;
 
    >div{
        width: 104px;
        text-align: center;
        padding: 20px 0;
        // display: flex;
        // justify-content: center;
        // flex-direction: column;
    }
    i{
        font-size: 20px;
    }
    p{
        display: block;
        text-align: center;
        padding: 12px 0;
        height: 20px;
        line-height: 20px;
    }
    .meeting-price-img{
        width: 18px;
        height: 18px;
        display: block;
        margin: 0 auto;
    }
}
.meeting-price-left .meeting-price-layout{
    width: 30px;
    text-align: center;
    padding: 0;
    display: flex;
    justify-content: center;
    font-size: 12px;
    flex-direction: column;
    border-right: 1px #d4deee dashed;
}
.meeting-price-bottom{
    background-color: var(--smtc-color-primary);
    color: #fff;
    height: 40px;
    width: 100px;
    display: block;
    float: right;
    border-radius: 4px;
    line-height: 40px;
    cursor: pointer;
    text-align: center;
}
.gallery-img {
  object-fit: cover;
  cursor: pointer;
  transition: 
  transform 0.6s cubic-bezier(0.25, 0.8, 0.25, 1), /* 缩放过渡（使用缓动函数增强质感） */
  filter 0.6s ease; /* 可选：添加亮度变化过渡 */
}
.text-red{
    color: #999;
}
</style>
